export default {
    init(button_id, max_posts, curr_posts) {
        let btn = document.getElementById(button_id);
        if(!btn) {
            throw new Error(button_id + ' does not exist');
        } else {
            if(curr_posts.length < max_posts) {
                btn.style.display = "block";
            } else {
                btn.style.display = "none";
            }
        }
    }
}